export const POS_SHORTCUTS = {
  PRODUCT_SEARCH: 'F1',
  CUSTOMER_SEARCH: 'F2',
  CUSTOMER_CREATE: 'F3',
  HOLD_BILL: 'F4',
  HELD_BILLS: 'F5',
  PAYMENT: 'F6',
  COMPLETE_SALE: 'F7',
  RETURN: 'F8',
  DISCOUNT: 'F9',
  PRINT_LABEL: 'F11',
  HELP: 'ctrl+/',
  CLEAR_CART: 'ctrl+delete',
  HOLD_CTRL: 'ctrl+h',
  PAYMENT_CTRL: 'ctrl+p',
  COMPLETE_CTRL: 'ctrl+enter',
  LINE_DISCOUNT: 'ctrl+d',
  QUICK_QTY: 'ctrl+q',
  REMOVE_LINE: 'delete',
} as const;

export const POS_SHORTCUT_HELP = [
  { category: 'Billing', key: 'F1', action: 'Focus product / barcode search' },
  { category: 'Billing', key: 'F4', action: 'Hold current bill' },
  { category: 'Billing', key: 'F5', action: 'Open held bills' },
  { category: 'Billing', key: 'F6', action: 'Open payment panel' },
  { category: 'Billing', key: 'F7', action: 'Complete sale / generate invoice' },
  { category: 'Billing', key: 'F9', action: 'Bill discount panel' },
  { category: 'Product', key: 'F11', action: 'Print barcode label (when label printer connected)' },
  { category: 'Billing', key: 'F10', action: 'Print last invoice (after sale)' },
  { category: 'Billing', key: 'Ctrl+Enter', action: 'Complete billing' },
  { category: 'Billing', key: 'Ctrl+Delete', action: 'Clear cart' },
  { category: 'Product', key: '↑ / ↓', action: 'Navigate product suggestions' },
  { category: 'Product', key: 'Enter', action: 'Add highlighted product' },
  { category: 'Cart', key: '↑ / ↓', action: 'Navigate cart lines' },
  { category: 'Cart', key: 'Enter', action: 'Edit quantity' },
  { category: 'Cart', key: '+ / -', action: 'Increase / decrease qty' },
  { category: 'Cart', key: 'Delete', action: 'Remove selected line' },
  { category: 'Cart', key: 'Ctrl+D', action: 'Line discount (qty modal)' },
  { category: 'Cart', key: 'Ctrl+Q', action: 'Quick quantity edit' },
  { category: 'Customer', key: 'F2', action: 'Focus customer search' },
  { category: 'Customer', key: 'F3', action: 'Quick create customer' },
  { category: 'Payment', key: '1–4', action: 'Cash / UPI / Card / Wallet' },
  { category: 'Payment', key: '↑ / ↓', action: 'Change payment method' },
  { category: 'Navigation', key: 'Esc', action: 'Close modal / restore focus' },
  { category: 'Navigation', key: 'Ctrl+/', action: 'Show all shortcuts' },
] as const;
